<template>
  <Modal title="Add Team Member" @close="close" @confirm="confirm" :hideFooter="true">
    <template #body>
      <LoadingState v-if="status.isLoading" />
      <TeamMemberAddForm v-else :teams="teams" @close="close" />
    </template>
  </Modal>
</template>

<script>
import { computed, onMounted } from "@vue/composition-api";
import LoadingState from "@/components/display/LoadingState";
import Modal from "@/components/display/Modal";
import store from "@/store";
import TeamMemberAddForm from "@/components/smart/forms/TeamMemberAddForm";

export default {
  name: "TeamMemberAddModal",
  components: {
    Modal,
    TeamMemberAddForm,
    LoadingState,
  },
  setup(props, { emit }) {
    onMounted(() => {
      store.dispatch("team/getList");
    });

    const close = () => {
      emit("close");
    };

    const confirm = () => {
      emit("confirm");
    };
    const teams = computed(() => store.getters["team/getList"]);
    const status = computed(() => store.getters["team/getListStatus"]);

    //Request URL: https://portal.qa.nxswd.net/user-role
    ///Request Method: GET

    //Request URL: https://portal.qa.nxswd.net/user
    //Request Method: POST
    //Body: {"email":"mcasanova@liquidweb.com","roles":["72816"]}

    return {
      close,
      confirm,
      teams,
      status,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/variables";
</style>
